import { Sun, Moon } from "lucide-react";
import { useTheme } from "../context/ThemeContext";

export default function ThemeToggle() {
  const { theme, toggle } = useTheme();
  const isDark = theme === "dark";
  return (
    <button
      onClick={toggle}
      data-testid="theme-toggle"
      aria-label="Toggle theme"
      className="relative inline-flex items-center w-14 h-7 rounded-full bg-zinc-200 dark:bg-zinc-800 transition-colors hover:bg-zinc-300 dark:hover:bg-zinc-700"
    >
      <span
        className={`absolute top-0.5 ${isDark ? "left-7" : "left-0.5"} w-6 h-6 rounded-full bg-white dark:bg-zinc-900 shadow-md transition-all duration-300 flex items-center justify-center`}
      >
        {isDark ? <Moon size={12} className="text-indigo-300" /> : <Sun size={12} className="text-orange-500" />}
      </span>
    </button>
  );
}
